import ProfileCardItem from "./ProfileCardItem";
import LoadMoreButton from 'common/LoadMoreButton/LoadMoreButton';
import CommonLoader from 'common/CommonLoader';

const PractitionerProfiles = (props) => {
    const { contents, hasMore, isLoading, loadingMore, fetchMoreProfileData } = props;

    return (
        <div style={{ height: "800px", overflow: "auto", marginTop: "10px", marginBottom: "20px" }}>
            {isLoading ?
                <div className="text-center">
                    <CommonLoader />
                </div>
                :
                <div>
                    {
                        contents.map((node, index) => (
                            <ProfileCardItem {...node} key={`profile_${index}`} />
                        ))
                    }
                    {hasMore &&
                        < div className="text-center mt-2">
                            {loadingMore ?
                                <CommonLoader style={{ width: "2rem", height: "2rem" }} />
                                :
                                <LoadMoreButton loadMore={fetchMoreProfileData} />
                            }
                        </div>
                    }
                </div>
            }
        </div>
    );
}


export default PractitionerProfiles;